// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerA1_banner__Dbm_g","loop":"BannerA1_loop__EfSMh"};